// https://github.com/AzureAD/azure-activedirectory-library-for-js/blob/master/lib/adal.js
import AuthenticationContext from 'adal-angular/lib/adal.js';

//Azure Ad Config
const config = {
    tenant: process.env.VUE_APP_TENANT,
    clientId: process.env.VUE_APP_CLIENT_ID,
    redirectUri: process.env.VUE_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.VUE_APP_POSTLOGOUT_REDIRECT_URI,
    cacheLocation: 'localStorage',
    expireOffsetSeconds: 1800 // Any requests using the token within 30mins will result in a refreshed token (when calling acquireToken)
};

export default {
    authenticationContext: null,
    /**
     * Init Azure ADAL
     * @return {Promise}
     */
    initialize() {
        this.authenticationContext = new AuthenticationContext(config);

        return new Promise((resolve, reject) => {
            if (this.authenticationContext.isCallback(window.location.hash)) // || window.self !== window.top 
            {
                // redirect to the location specified in the url params.
                this.authenticationContext.handleWindowCallback();
            } else {
                // try pull the user out of local storage
                let user = this.authenticationContext.getCachedUser();

                if (user) {
                    resolve();
                } else {
                    reject();
                }
            }
        });
    },
    /**
     * Acquire Token
     */
    acquireToken() {
        return new Promise((resolve, reject) => {
            this.authenticationContext.acquireToken(config.clientId, (error, token) => {
                if (error || !token) {
                    reject({
                        tokenError: error
                    });
                    return;
                }

                resolve(token);
                return;
            });
        });
    },
    /**
     * @return An ADAL user profile .
     */
    getADProfile() {
        if (this.authenticationContext && this.authenticationContext.getCachedUser() && this.authenticationContext.getCachedUser().profile) {
            var profile = this.authenticationContext.getCachedUser().profile;
            return profile;
        } else {
            return "";
        }
    },
    /**
     * Sign in
     */
    signIn() {
        this.authenticationContext.login();
    },
    /**
     * Sign out
     */
    signOut(localOnly) {
        if(localOnly) {
            this.authenticationContext.clearCache();
        } else {
            this.authenticationContext.logOut();
        }      
    }
}
